// extracted by mini-css-extract-plugin
module.exports = {"container":"DepartmentsPage_container__2_S3g","page":"DepartmentsPage_page__39XeO","topSpan":"DepartmentsPage_topSpan__3SOSM","right":"DepartmentsPage_right__1HRwH"};